import { defineComponent as _defineComponent } from 'vue'
import type { Price, Subscription } from '@/@types/billing';
import PlanTab from '@/components/pages/billing/PlansPage/Plantab/PlanTab.vue';
import { computed } from 'vue';
import { SubscriptionType } from '@/@types/enums/SubscriptionType';


export default /*#__PURE__*/_defineComponent({
  __name: 'PricingTabs',
  props: {
    prices: null,
    subscription: null,
    companyPaddleStatus: null,
    isUpdatePlan: { type: Boolean }
  },
  emits: ["subscribe", "update"],
  setup(__props: any) {

const props = __props as {
  prices: Price[];
  subscription: Subscription;
  companyPaddleStatus: SubscriptionType | null;
  isUpdatePlan: boolean;
}





const filteredPrices = computed(() => {
  if (props.subscription || props.companyPaddleStatus) {
    return props.prices.filter((price) => {
      const currentPriceId = props.subscription?.items[0]?.price.id;
      const currentBillingCycle = props.subscription?.items[0]?.price.billingCycle.interval;

      return price.id !== currentPriceId && price.billingCycle.interval !== currentBillingCycle && !price.trialPeriod;
    });
  }

  return props.prices.filter((price) =>
    price.billingCycle.interval === 'month' ? !!price.trialPeriod : price.billingCycle.interval === 'year'
  );
});

const hasNothingToBuy = computed(() => props.prices.length > 0 && filteredPrices.value.length === 0);

return { __sfc: true,props, filteredPrices, hasNothingToBuy, PlanTab }
}

})